import { SECTION_TYPES } from "@/lib/constants/sections";
import { Code } from "lucide-react";

const iframeSection = {
  type: SECTION_TYPES.IFRAME,
  editingDisabled: false,
  content: {
    customCode: "",
  },
  meta: {
    displayName: "Custom Code",
    displayDescription: "Embed custom code on this page.",
    displayIcon: Code,
  },
};

export default iframeSection;
